module.exports = __webpack_public_path__ + "static/assets/64fb76f8fe9cebb6a81f0648a0cdae67.png";